import { render, staticRenderFns } from "./TabIcon.vue?vue&type=template&id=05aa406a&"
import script from "./TabIcon.vue?vue&type=script&lang=js&"
export * from "./TabIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports